import _chunk from "lodash/chunk";
import _initial from "lodash/initial";

export function base64ToArrayBuffer(base64: string) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

export async function fileToBase64String(file: File) {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  return new Promise<string>((resolve) => {
    // resolveni promise až z onload callbacku na readeru
    reader.onload = () => {
      resolve(reader.result?.toString().split(",")[1] ?? "");
    };
  });
}

export const getAppEnvironment = (): string | undefined => {
  const baseHref = document
    .getElementsByTagName("base")[0]
    ?.getAttribute("href");

  if (!baseHref) return undefined;

  return baseHref.replace(/\//g, "").toUpperCase();
};
